import React, { useState, useEffect } from 'react';

const SidebarBanners = () => {
    const [currentImage, setCurrentImage] = useState(0);
    const images = [
        '/banners/Banner_1.jpg',
        '/banners/Banner_2.jpg',
        '/banners/Banner_3.jpg'
    ];

    useEffect(() => {
        const intervalId = setInterval(() => {
            setCurrentImage((prevImage) => (prevImage + 1) % images.length);
        }, 3000); // Cambia la imagen cada 3 segundos (más rápido)

        return () => clearInterval(intervalId);
    }, [images.length]);

    return (
        <div className="sidebar-banner-container mt-4 px-3 mb-4 text-center" style={{ width: '100%', overflow: 'hidden' }}>
            <style>
                {`
                    @keyframes fadeInBanner {
                        from { opacity: 0; }
                        to { opacity: 1; }
                    }
                    /* Oculta los banners cuando el menú lateral está colapsado */
                    body.mini-sidebar .sidebar-banner-container {
                        display: none !important;
                    }
                `}
            </style>
            {images.map((img, index) => (
                <img
                    key={index}
                    src={img}
                    alt={`Banner Megatone ${index + 1}`}
                    className="img-fluid rounded shadow-sm"
                    style={{
                        display: index === currentImage ? 'block' : 'none',
                        width: '100%',
                        height: 'auto',
                        objectFit: 'cover',
                        animation: index === currentImage ? 'fadeInBanner 0.3s ease-in' : 'none'
                    }}
                />
            ))}
        </div>
    );
};

export default SidebarBanners;
